<template>
  <div>
    <b-button variant="primary" @click="newSystem">New System</b-button>
    <br />
    <br />
    <template v-for="system in systems">
      <b-card>
        <div style="border-bottom: solid 1px #efefef">
          <div style="display:flex">
            <div style="padding:25px">
              <img :src="system.dashboardImageUrl" style="width:75px" />
            </div>
            <div style="padding:25px">
              <b
                ><a :href="'/#/admin/system/' + system.id">{{ system.name }}</a
                ><br
              /></b>
              {{ system.domain }}<br />
              <div class="text-muted">
                {{ system.phoneNumber | phonenumber }}<br />
                <br />
                {{ system.url }}<br />
                {{ system.email }}<br />
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      systems: null,
    };
  },
  async created() {
    let r = await this.$client.get("/api/system/getSystems");
    this.systems = r.data.value.systems;
  },
  methods: {
    newSystem() {
      location.href = "/#/admin/system";
    },
    systemClicked(e) {
      location.href = "/#/admin/system/" + e.id;
    },
  },
};
</script>

<style></style>
